export const productOptions = [
    { value: "Personal Loan", label: "Personal Loan" },
    { value: "Business Loan", label: "Business Loan" },
    { value: "Two Wheeler", label: "Two Wheeler" },
    { value: "Credit Card", label: "Credit Card" },
];
